import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=42e67b1f&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=42e67b1f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e67b1f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42e67b1f')) {
      api.createRecord('42e67b1f', component.options)
    } else {
      api.reload('42e67b1f', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=42e67b1f&scoped=true&", function () {
      api.rerender('42e67b1f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2oemp7vQ8aIdh/JS/teamMember.vue"
export default component.exports